import HttpClientXml from "../utils/HttpClientXml";

// --------- POST API ------------

export const addState = async (data) => {
  let endPoint = "state";
  return HttpClientXml.post(endPoint, data);
};

export const addDistrict = async (data) => {
  let endPoint = "district";
  return HttpClientXml.post(endPoint, data);
};

export const addCity = async (data) => {
  let endPoint = "city";
  return HttpClientXml.post(endPoint, data);
};

export const addUniversity = async (data) => {
  let endPoint = "university";
  return HttpClientXml.post(endPoint, data);
};

export const addCourseCategory = async (data) => {
  let endPoint = "course-category";
  return HttpClientXml.post(endPoint, data);
};

export const addCourse = async (data) => {
  let endPoint = "course-degree";
  return HttpClientXml.post(endPoint, data);
};

export const addCollege = async (data) => {
  let endPoint = "college";
  return HttpClientXml.post(endPoint, data);
};

// --------- GET API --------------
export const getStates = async () => {
  let endPoint = "state";
  return HttpClientXml.get(endPoint);
};

export const getDistricts = async () => {
  let endPoint = "district";
  return HttpClientXml.get(endPoint);
};

export const getCities = async () => {
  let endPoint = "city";
  return HttpClientXml.get(endPoint);
};

export const getUniversities = async () => {
  let endPoint = "university";
  return HttpClientXml.get(endPoint);
};

export const getCourseCategories = async () => {
  let endPoint = "course-category";
  return HttpClientXml.get(endPoint);
};

export const getCourses = async () => {
  let endPoint = "course-degree";
  return HttpClientXml.get(endPoint);
};

export const getColleges = async () => {
  let endPoint = "college";
  return HttpClientXml.get(endPoint);
};

// --------- PUT API --------------
export const updateState = async (id, data) => {
  let endPoint = `state/${id}`;
  return HttpClientXml.put(endPoint, data);
};

export const updateDistrict = async (id, data) => {
  let endPoint = `district/${id}`;
  return HttpClientXml.put(endPoint, data);
};

export const updateCity = async (id, data) => {
  let endPoint = `city/${id}`;
  return HttpClientXml.put(endPoint, data);
};

export const updateUniversity = async (id, data) => {
  let endPoint = `university/${id}`;
  return HttpClientXml.put(endPoint, data);
};

export const updateCourseCategory = async (id, data) => {
  let endPoint = `course-category/${id}`;
  return HttpClientXml.put(endPoint, data);
};

export const updateCourse = async (id, data) => {
  let endPoint = `course-degree/${id}`;
  return HttpClientXml.put(endPoint, data);
};

export const updateCollege = async (id, data) => {
  let endPoint = `college/${id}`;
  return HttpClientXml.put(endPoint, data);
};

// --------- DELETE API -------------
export const deleteState = async (id) => {
  let endPoint = `state/${id}`;
  return HttpClientXml.deletemethod(endPoint);
};

export const deleteDistrict = async (id) => {
  let endPoint = `district/${id}`;
  return HttpClientXml.deletemethod(endPoint);
};

export const deleteCity = async (id) => {
  let endPoint = `city/${id}`;
  return HttpClientXml.deletemethod(endPoint);
};

export const deleteUniversity = async (id) => {
  let endPoint = `university/${id}`;
  return HttpClientXml.deletemethod(endPoint);
};

export const deleteCourseCategory = async (id) => {
  let endPoint = `course-category/${id}`;
  return HttpClientXml.deletemethod(endPoint);
};

export const deleteCourse = async (id) => {
  let endPoint = `course-degree/${id}`;
  return HttpClientXml.deletemethod(endPoint);
};

export const deleteCollege = async (id) => {
  let endPoint = `college/${id}`;
  return HttpClientXml.deletemethod(endPoint);
};

//// Course Fees /////
export const addCourseFees = async (data) => {
  let endPoint = "course-fees";
  return HttpClientXml.post(endPoint, data);
};

export const getCourseFees = async () => {
  let endPoint = "course-fees";
  return HttpClientXml.get(endPoint);
};

export const updateCourseFees = async (id, data) => {
  let endPoint = `course-fees/${id}`;
  return HttpClientXml.put(endPoint, data);
};

export const deleteCourseFees = async (id) => {
  let endPoint = `course-fees/${id}`;
  return HttpClientXml.deletemethod(endPoint);
};

export const topCourseFeesStatus = async (data) => {
  let endPoint = `course-fees-top-status-change`;
  return HttpClientXml.put(endPoint, data);
};

export const topFeaturedCourseStatus = async (data) => {
  let endPoint = `course-fees-featured-status-change`;
  return HttpClientXml.put(endPoint, data);
};

////// Country ////////
export const addCountry = async (data) => {
  let endPoint = "country";
  return HttpClientXml.post(endPoint, data);
};
export const getCountries = async () => {
  let endPoint = "country";
  return HttpClientXml.get(endPoint);
};
export const updateCountry = async (id, data) => {
  let endPoint = `country/${id}`;
  return HttpClientXml.put(endPoint, data);
};
export const deleteCountry = async (id) => {
  let endPoint = `country/${id}`;
  return HttpClientXml.deletemethod(endPoint);
};

//// College Steps Data /////
export const getCollegeDetails = async (id) => {
  let endPoint = `college-details/${id}`;
  return HttpClientXml.get(endPoint);
};
export const updateCollegeDetails = async (id, data) => {
  let endPoint = `edit-college-with-add-more/${id}`;
  return HttpClientXml.put(endPoint, data);
};

export const addCollegeFacility = async (data) => {
  let endPoint = `college-wise-facility-add`;
  return HttpClientXml.post(endPoint, data);
};

//// Scholarship /////
export const addScholarship = async (data) => {
  let endPoint = "scholarship";
  return HttpClientXml.post(endPoint, data);
};

export const getScholarship = async () => {
  let endPoint = "scholarship";
  return HttpClientXml.get(endPoint);
};

export const updateScholarship = async (id, data) => {
  let endPoint = `scholarship/${id}`;
  return HttpClientXml.put(endPoint, data);
};

export const deleteScholarship = async (id) => {
  let endPoint = `scholarship/${id}`;
  return HttpClientXml.deletemethod(endPoint);
};

//// Blog /////
export const addBlog = async (data) => {
  let endPoint = "blog";
  return HttpClientXml.post(endPoint, data);
};

export const getBlog = async () => {
  let endPoint = "blog";
  return HttpClientXml.get(endPoint);
};

export const updateBlog = async (id, data) => {
  let endPoint = `blog/${id}`;
  return HttpClientXml.put(endPoint, data);
};

export const deleteBlog = async (id) => {
  let endPoint = `blog/${id}`;
  return HttpClientXml.deletemethod(endPoint);
};

export const getBlogByCollege = async (id) => {
  let endPoint = `blog-by-college/${id}`;
  return HttpClientXml.get(endPoint);
};

///// Gallery /////
export const getGalleryByCollege = async (id) => {
  let endPoint = `gallery-check-by-college/${id}`;
  return HttpClientXml.get(endPoint);
};

export const addGallery = async (data) => {
  let endPoint = "gallery";
  return HttpClientXml.post(endPoint, data);
};

export const updateGallery = async (id, data) => {
  let endPoint = `gallery/${id}`;
  return HttpClientXml.put(endPoint, data);
};

///// CutOffs /////
export const addCutOffs = async (data) => {
  let endPoint = "cutt-off";
  return HttpClientXml.post(endPoint, data);
};

export const getCutOffsByCollege = async (id) => {
  let endPoint = `cutt-off-by-college/${id}`;
  return HttpClientXml.get(endPoint);
};

//// Facility /////
export const addFacility = async (data) => {
  let endPoint = "facility";
  return HttpClientXml.post(endPoint, data);
};

export const getFacilities = async () => {
  let endPoint = "facility";
  return HttpClientXml.get(endPoint);
};

export const updateFacility = async (id, data) => {
  let endPoint = `facility/${id}`;
  return HttpClientXml.put(endPoint, data);
};

export const deleteFacility = async (id) => {
  let endPoint = `facility/${id}`;
  return HttpClientXml.deletemethod(endPoint);
};

export const getFacilitiesByCollege = async (id) => {
  let endPoint = `college-wise-facility-get/${id}`;
  return HttpClientXml.get(endPoint);
};

export const getOverviewCourses = async (id) => {
  let endPoint = `overview-course/${id}`;
  return HttpClientXml.get(endPoint);
};

export const addOverviewCourse = async (data) => {
  let endPoint = `overview-course`;
  return HttpClientXml.post(endPoint, data);
};

export const getProfile = async () => {
  let endPoint = "profile";
  return HttpClientXml.get(endPoint);
};

export const addAccredition = async (data) => {
  let endPoint = "master/accreditation";
  return HttpClientXml.post(endPoint, data);
};

export const getAccredition = async () => {
  let endPoint = `master/accreditation`;
  return HttpClientXml.get(endPoint);
};

export const updateAccredition = async (id, data) => {
  let endPoint = `master/accreditation/${id}`;
  return HttpClientXml.put(endPoint, data);
};

export const deleteAccredition = async (id) => {
  let endPoint = `master/accreditation/${id}`;
  return HttpClientXml.deletemethod(endPoint);
};
export const addExam = async (data) => {
  let endPoint = "master/exam";
  return HttpClientXml.post(endPoint, data);
};

export const getExam = async () => {
  let endPoint = `master/exam`;
  return HttpClientXml.get(endPoint);
};

export const updateExam = async (id, data) => {
  let endPoint = `master/exam/${id}`;
  return HttpClientXml.put(endPoint, data);
};

export const deleteExam = async (id) => {
  let endPoint = `master/exam/${id}`;
  return HttpClientXml.deletemethod(endPoint);
};
